// extracted by mini-css-extract-plugin
export var access = "GatedForm-module--access--95395";
export var container = "GatedForm-module--container--9f92e";
export var disabled = "GatedForm-module--disabled--136b8";
export var formContainer = "GatedForm-module--form-container--f8a86";
export var heroImage = "GatedForm-module--hero-image--f8462";
export var hideForm = "GatedForm-module--hide-form--dc9bc";
export var imgContainer = "GatedForm-module--img-container--95b5c";
export var rotate = "GatedForm-module--rotate--1bc90";
export var spinner = "GatedForm-module--spinner--ca067";
export var success = "GatedForm-module--success--5c4d3";